import styled from "styled-components"
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../../../ui/tabs"
import { Button } from "../../../ui/button"

import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger,
} from "../../../ui/dropdown-menu"
import { Input } from "../../../ui/input"

import SimpleTable from '../../components/SimpleTable'
import { useEffect, useState } from "react"
import { useNavigate, useParams } from 'react-router-dom'
import { Alert, Row, Col, Modal, Spin, Toaster, toast, Form, Select } from './../../../ui/ot'
import CheckoutsHistoryProTableOt from './../../components/CheckoutsHistoryProTableOt'
import { useBorrower } from "../../controllers/BorrowerController"
import { useItem } from './../../controllers/ItemController';
import { useCheckout } from "../../controllers/CheckoutController"
import { useHold } from "../../controllers/HoldController"
import { useLibrary } from "../../controllers/LibraryController"
import HoldsProTableOt from "../../components/HoldsProTableOt"
import { useTranslation } from 'react-i18next';


const CheckOutHistory = ({
    keyPrefix = "library.backstage.Patrons.CheckOutHistory",
    permission_level = null, 
}) => {
    const { t } = useTranslation('translation', { keyPrefix: keyPrefix })
    const { borrowernumber } = useParams()
    const navigate = useNavigate()

    const {
        BorrowerData,
        getBorrowerData,
    } = useBorrower({
        onBefore: () => {

        },
        onFinish: () => {

        }
    })
    useEffect(() => {
        getBorrowerData({
            borrowernumber: borrowernumber
        })
    }, [borrowernumber])

    const borrower = BorrowerData?.find(_ => true)

    return (
        <>
            <Toaster richColors position="top-center" />
            <MainContainer>
                {/* <LanContainer>
                    <WhiteBox>
                        <Row gutter={[8, 8]}>
                            <CheckoutForm
                                borrowernumber={borrowernumber}
                                borrower={borrower}
                                onCheckout={({ itemnumber }) => postCheckoutData([
                                    {
                                        borrowernumber: borrowernumber,
                                        itemnumber: itemnumber
                                    }
                                ])}
                                onHold={({ itemnumber, pickupLibrary }) => postHoldData([
                                    {
                                        borrowernumber: borrowernumber,
                                        itemnumber: itemnumber,
                                        pickupLibrary: pickupLibrary
                                    }
                                ])}
                            />
                        </Row>
                    </WhiteBox>
                </LanContainer> */}
                <Tabs defaultValue="0" className="w-full">
                    <TabsContent value="0">
                        <WhiteBox>
                            <CheckoutsHistoryProTableOt
                                // borrowernumber={borrowernumber}
                                // keyPrefix={keyPrefix + ".borrowed_list"}
                                permission_level={permission_level}
                                defaultOrder={[{
                                    column: "issue_issuedate",
                                    type: "ASC",
                                }]}
                            />
                        </WhiteBox>
                    </TabsContent>
                </Tabs>
            </MainContainer>
        </>
    )
}

const MainContainer = styled.div`
width: 100%;
display: flex;
-webkit-box-pack: center;
justify-content: space-around;
flex-direction: column;
-webkit-box-align: start;
align-items: start;
// padding: 2em;
gap: 0.5em;
-webkit-flex-wrap: wrap;
`

const LanContainer = styled.div`
width: 100%;
display: flex;
-webkit-box-pack: center;
justify-content: space-around;
flex-direction: row;
-webkit-box-align: start;
align-items: start;
gap: 0.5em;
flex-wrap: nowrap;
`

const SubTitle = styled.div`
text-align: left;
// width: 90%;
font-size: 1.1em;
font-weight: 600;
padding-bottom: 0.5em;
}
`

const WhiteBox = styled.div`
background - color: #fff;
padding: 1em;
width: -webkit - fill - available;
`

export default CheckOutHistory

